export interface TradePairState {
    firstCurrencySymbol: string,
    firstCurrencyId: number,
    firstFloatDigit: number,
    secondCurrencySymbol: number,
    secondCurrencyId: number,
    secondFloatDigit: number,
    botstatus: string,
    tikerRoot: string,
    _id: string,
    maker_rebate: number,
    taker_fees: number
}

export const initialState: any = {}
